import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import { ProducerUrlManagerInterface } from 'modules/producers/interfaces/producer-url-manager.interface';

export enum FiltersActions {
    SET_FILTER = 'SET_FILTER',
    UNSET_FILTER = 'UNSET_FILTER',
    SET_PRICE = 'SET_PRICE',
}

export const producerUrlManager = [
    (
        state: ProducerUrlManagerInterface,
        action: ReduxSimpleActionInterface<FiltersActions.SET_FILTER | FiltersActions.UNSET_FILTER, { id: string; }> |
            ReduxSimpleActionInterface<FiltersActions.SET_PRICE, { price: { min: number; max: number; };}>
    ): ProducerUrlManagerInterface => {
        switch (action.type) {
            case FiltersActions.SET_FILTER:
                return { ...state, page: 1, filters: [...state.filters ?? [], action.id] };
            case FiltersActions.UNSET_FILTER:
                return { ...state, page: 1, filters: [...state.filters ?? []].filter(id => id !== action.id) };
            case FiltersActions.SET_PRICE:
                return { ...state, page: 1, price: { min: action.price.min, max: action.price.max } };
            default:
                return state;
        }
    }
];
